import { CharField, LinkField, SingleSelectField } from "@inmagik/magik-ui"
import { getIn, useFormikContext } from "formik"
import { Col } from "react-bootstrap"
import type { NamedEntity } from "../../types"
import { NAMED_ENTITY_TYPES } from "../../constants"
import { WysiwygField } from "../../components/WysiwygField"

export default function NamedEntityForm({ col = 8 }: { col?: number }) {
  const { setFieldValue, values, errors, submitCount } = useFormikContext<NamedEntity>()

  return (
    <Col xs={col} className="d-flex flex-column align-items-stretch gap-4">
      <CharField
        label="Nome"
        layout="horizontal"
        value={values.name}
        onChange={(value) => {
          setFieldValue("name", value)
        }}
        isValid={submitCount > 0 ? !getIn(errors, "name") : undefined}
        errorMessage={getIn(errors, "name")}
        required
      />

      <SingleSelectField
        label="Ruolo"
        layout="horizontal"
        options={NAMED_ENTITY_TYPES}
        value={NAMED_ENTITY_TYPES.find((type) => type.value === values.entity_type) || null}
        onChange={(value) => {
          setFieldValue("entity_type", value?.value || "")
        }}
        isValid={submitCount > 0 ? !getIn(errors, "entity_type") : undefined}
        errorMessage={getIn(errors, "entity_type")}
        required
      />
      <WysiwygField
        label={values.entity_type === "AUTHOR" ? "Biografia" : "Descrizione"}
        layout="horizontal"
        value={values.description || ""}
        onChange={(value) => {
          setFieldValue("description", value)
        }}
      />
      <LinkField
        label="Link"
        layout="horizontal"
        value={values.link || ""}
        onChange={(value) => {
          setFieldValue("link", value)
        }}
      />
    </Col>
  )
}
